"use strict";
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonTraceSerializer = exports.JsonMetricsSerializer = exports.JsonLogsSerializer = exports.ProtobufTraceSerializer = exports.ProtobufMetricsSerializer = exports.ProtobufLogsSerializer = void 0;
var protobuf_1 = require("./logs/protobuf");
Object.defineProperty(exports, "ProtobufLogsSerializer", { enumerable: true, get: function () { return protobuf_1.ProtobufLogsSerializer; } });
var protobuf_2 = require("./metrics/protobuf");
Object.defineProperty(exports, "ProtobufMetricsSerializer", { enumerable: true, get: function () { return protobuf_2.ProtobufMetricsSerializer; } });
var protobuf_3 = require("./trace/protobuf");
Object.defineProperty(exports, "ProtobufTraceSerializer", { enumerable: true, get: function () { return protobuf_3.ProtobufTraceSerializer; } });
var json_1 = require("./logs/json");
Object.defineProperty(exports, "JsonLogsSerializer", { enumerable: true, get: function () { return json_1.JsonLogsSerializer; } });
var json_2 = require("./metrics/json");
Object.defineProperty(exports, "JsonMetricsSerializer", { enumerable: true, get: function () { return json_2.JsonMetricsSerializer; } });
var json_3 = require("./trace/json");
Object.defineProperty(exports, "JsonTraceSerializer", { enumerable: true, get: function () { return json_3.JsonTraceSerializer; } });
//# sourceMappingURL=index.js.map